<template>
    <teleport to="body">
        <div v-if="message !== null" class="undo-toast toast show align-items-center text-bg-dark border-0" role="status" aria-live="polite">
            <div class="d-flex align-items-center">
                <div class="toast-body">{{ message }}</div>
                <button type="button" class="btn btn-sm btn-link text-warning fw-semibold me-2" @click="$emit('undo')">
                    Vrátit zpět
                </button>
            </div>
        </div>
    </teleport>
</template>

<script lang="ts">
import {defineComponent, PropType} from 'vue';

export default defineComponent({
    props: {
        message: {type: String as PropType<string | null>, required: true},
    },

    emits: ['undo'],
});
</script>
